/* ── DREAMY DIAPER CREATIONS — Theme JS ── */

// ── HEADER SCROLL SHRINK ──
(function () {
  const header = document.querySelector('header');
  if (!header) return;
  const isHome = document.body.classList.contains('template-index');
  if (!isHome) {
    header.classList.add('scrolled');
    return;
  }
  function onScroll() {
    header.classList.toggle('scrolled', window.scrollY > 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ── MOBILE NAV ──
function openMobileNav() {
  document.querySelector('.mobile-nav').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeMobileNav() {
  document.querySelector('.mobile-nav').classList.remove('open');
  document.body.style.overflow = '';
}
function toggleMobileShop(btn) {
  const sub = btn.nextElementSibling;
  const arrow = btn.querySelector('.mobile-shop-arrow');
  sub.classList.toggle('open');
  arrow.style.transform = sub.classList.contains('open') ? 'rotate(180deg)' : 'rotate(0deg)';
}

// ── HERO SLIDESHOW ──
(function () {
  const slides = document.querySelectorAll('.slide');
  const dots = document.querySelectorAll('.slide-dots button');
  if (!slides.length) return;
  let current = 0;
  let timer = setInterval(() => goToSlide((current + 1) % slides.length), 5000);

  function goToSlide(n) {
    slides[current].classList.remove('active');
    dots[current] && dots[current].classList.remove('active');
    current = n;
    slides[current].classList.add('active');
    dots[current] && dots[current].classList.add('active');
    clearInterval(timer);
    timer = setInterval(() => goToSlide((current + 1) % slides.length), 5000);
  }

  window.goToSlide = goToSlide;
  window.prevSlide = () => goToSlide((current - 1 + slides.length) % slides.length);
  window.nextSlide = () => goToSlide((current + 1) % slides.length);
})();

// ── RECIPIENT SELECTOR (checkout) ──
function selectRecipient(val) {
  const self = document.getElementById('lbl-self');
  const gift = document.getElementById('lbl-gift');
  if (!self || !gift) return;
  self.style.borderColor = val === 'self' ? 'var(--blue)' : 'var(--sand-mid)';
  gift.style.borderColor = val === 'gift' ? 'var(--blue)' : 'var(--sand-mid)';
  self.style.background   = val === 'self' ? 'var(--blue-light)' : 'var(--white)';
  gift.style.background   = val === 'gift' ? 'var(--blue-light)' : 'var(--white)';
}

// ── FAQ ACCORDION ──
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// ── SHIPPING OPTION SELECTOR ──
function selectShipping(el) {
  document.querySelectorAll('.shipping-option').forEach(o => o.classList.remove('selected'));
  el.classList.add('selected');
}
